import React from 'react';
import { colorGunmetal } from '../../../../theme/color';
import { MoreHoriz } from '../icons/MoreHoriz';
import { ComponentProps, inject, deps, observer } from '../../../../lib/component';
import { TrackSchema } from '../../../../types/schema';
import { CircleButton } from './CircleButton';
import { ButtonProminence } from './buttonStyles';
import { style, classes } from 'typestyle';
import { px } from 'csx';

interface TrackInfoButtonProps extends ComponentProps {
  track: TrackSchema;
  className?: string;
}

const styles = style({
  width: px(32),
  height: px(32),
});

export const TrackInfoButton: React.FC<TrackInfoButtonProps> = inject(deps)(
  observer(({ track, className, controller }) => {
    const handleClickTrackInfo = (event: React.MouseEvent<any>): void => {
      controller.modal.showSongInfoModal(track);
    };

    return (
      <CircleButton
        className={classes(styles, className)}
        prominence={ButtonProminence.SECONDARY}
        onClick={handleClickTrackInfo}
        data-test-track-info
        aria-label="View more information about this track"
      >
        <MoreHoriz color={colorGunmetal.toString()} size={16} />
      </CircleButton>
    );
  })
);
